import React, { useState } from 'react'
import { Link, } from 'react-router-dom'
import { Navbar } from 'react-bootstrap'

function Daftar() {

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const getUsername = (e) => {
        const value = e.target.value
        setUsername(value)
    }
    const getEmail = (e) => {
        const value = e.target.value
        setEmail(value)
    }
    const getPassword = (e) => {
        const value = e.target.value
        setPassword(value)
    }

    return (
        <div>
            <Navbar expand="lg" className='navbar'>
                <div>
                    <Link to='/' className='brand'>EzStay</Link>
                </div>
            </Navbar>
            <div className='kartu mt-3'>
                <form>
                    <div class="form-group">
                        <label for="username">Username</label>
                        <input type="text" class="form-control" id="email" aria-describedby="emailHelp" value={username} onChange={getUsername} />
                    </div>
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" class="form-control" id="email" aria-describedby="emailHelp" value={email} onChange={getEmail} />
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" class="form-control" id="password" value={password} onChange={getPassword} />
                    </div>
                    <button type="submit" class="btn btn-primary mt-3">Submit</button>
                </form>
            </div>
        </div>
    )
}

export default Daftar
